import React from 'react';
import { socialProof } from '../data/content';

// La imagen trae su propio título en la parte superior (≈21% de su alto).
// Se recorta visualmente para mostrar el encabezado de la página en su lugar.
const IMAGE_ASPECT = 1536 / 1024;
const HEADER_CROP = 0.21;
export function SocialProof() {
  return <section className="bg-parchment-light text-ink" data-id="element-166" data-mp="3btvbhy3xko7t">
      <div className="mx-auto max-w-content px-4 py-14 sm:px-6 lg:py-20" data-id="element-167" data-mp="3bwrbdrzc9myw">
        <div className="mx-auto max-w-2xl text-center" data-id="element-168" data-mp="3fd849oxpwuj">
          <h2 className="font-display text-[1.875rem] font-semibold leading-tight tracking-tight text-ink sm:text-4xl" data-id="element-169" data-mp="8ehhp1frtwle">
            {socialProof.title}
          </h2>
          <p className="mt-4 font-sans text-base leading-relaxed text-ink-soft sm:text-lg" data-id="element-170" data-mp="3pslji8sag8ay">
            {socialProof.subtitle}
          </p>
        </div>

        <div className="mx-auto mt-8 w-full max-w-lg overflow-hidden" style={{
        aspectRatio: `1 / ${IMAGE_ASPECT * (1 - HEADER_CROP)}`
      }} data-id="element-171" data-mp="mco5tpux4i7v">
          <img src={socialProof.image} alt={socialProof.imageAlt} loading="lazy" className="block h-auto w-full mix-blend-multiply" style={{
          marginTop: `-${IMAGE_ASPECT * HEADER_CROP * 100}%`
        }} data-id="element-172" data-mp="1u9l7df9t0faw" />
        </div>
      </div>
    </section>;
}